import { rules } from '../Discount/rules';
import { tRule } from '../Discount/types/rules';

const cashbackRules: tRule[] = [
  ...rules,
  {
    id: 'bin_numbers',
    description: 'Bins',
    ref: 'bin_numbers',
    isArray: true,
  }
];

export { cashbackRules };
